import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34ccc460"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, "Данные для авторизации", -1))
const _hoisted_4 = { class: "flex some-inputs m-t-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Логин/почта", -1))
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col input-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Пароль", -1))
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "form-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title bold" }, "Личные данные", -1))
const _hoisted_11 = { class: "flex some-inputs m-t-8" }
const _hoisted_12 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Фамилия", -1))
const _hoisted_14 = { class: "flex flex-col input-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Имя", -1))
const _hoisted_16 = { class: "form-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title bold" }, "Организация пользователя", -1))
const _hoisted_18 = { class: "flex some-inputs m-t-8" }
const _hoisted_19 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Организация", -1))
const _hoisted_21 = { class: "flex flex-col input-container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Департамент", -1))
const _hoisted_23 = { class: "flex m-t-8" }
const _hoisted_24 = { class: "flex flex-col fl-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Роль", -1))

import { ref, watch, onMounted, computed } from "vue";

import InputText from "primevue/inputtext";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";

import { useRoute, useRouter } from "vue-router";

import { generatePassword } from "@/services/utils/Password";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import { useOrganizationsDictionaryStore } from "@/store/catalog_data/organizations";
import { useOrganizationsStore } from "@/store/dictionaries/organizations";
import { useUsersStore } from "@/store/users/users";
import { Department } from "@/store/dictionaries/organizations";
import { isFilledUser } from "@/services/dictionaries/users";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const route = useRoute();
const router = useRouter();
const store = useUsersStore();
const orgDictionaryStore = useOrganizationsDictionaryStore();
const organizationsStore = useOrganizationsStore();

const user = ref({
  fname: "",
  lname: "",
  organization: null as number | null,
  department: null as number | null,
  role: null as number | null,
  email: "",
  password: "",
});

const passwordClosed = ref(true);
const isInvalidForm = ref(false);
const departments = ref([] as Department[]);
const isDemoOrganization = ref(false);
const isUserSetted = computed(() => {
  return Boolean(route.params.id);
});

watch(
  () => user.value.organization,
  () => {
    setDepartments();
  }
);

watch(
  () => orgDictionaryStore.itemList,
  () => {
    setDepartments();
  }
);

const reload = () => {
  if (isUserSetted.value) {
    const userId = parseInt(route.params.id);
    store.getUser(userId).then((userClone) => {
      if (userClone) {
        user.value.fname = userClone.fname;
        user.value.lname = userClone.lname;
        user.value.email = userClone.email;
        user.value.role = userClone.role.id;
        user.value.department = userClone.role.department.id;
        user.value.organization = userClone.role.department.organization.id;
        isDemoOrganization.value = Boolean(
          userClone.role.department.organization.is_demo
        );
        if (isDemoOrganization.value) {
          loadOrganizationsWithDemo();
        }
      }
    });
  }
  setDepartments();
};

const loadOrganizationsWithDemo = () => {
  organizationsStore
    .getOrganizations({ page: 1, per_page: 100, include_demo: true, order_by: "name" })
    .then(() => {
      orgDictionaryStore.itemList = organizationsStore.organizationsList as any;
    });
};

onMounted(() => {
  reload();
});

const passClick = () => {
  passwordClosed.value = !passwordClosed.value;
};

const passGenerate = () => {
  user.value.password = generatePassword(16);
};

const setDepartments = () => {
  if (user.value.organization) {
    const foundItem = orgDictionaryStore.itemList.find(
      (item) => item.id === user.value.organization
    );
    if (foundItem) {
      departments.value = foundItem.departments;
      return;
    }
  }
  departments.value = [];
};

const getRoles = () => {
  if (user.value.department && departments.value) {
    const foundItem = departments.value.find(
      (item) => item.id === user.value.department
    );
    if (foundItem) return foundItem.roles;
  }
  return [];
};

const createUser = () => {
  if (!isFilledUser(user.value, !isUserSetted.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }

  const userForCreation = {
    fname: user.value.fname,
    lname: user.value.lname,
    email: user.value.email,
    password: user.value.password,
    role_id: user.value.role,
  };

  emit("setLoading", true);
  if (isUserSetted.value)
    performAction(() =>
      store.updateUser(userForCreation, parseInt(route.params.id))
    );
  else performAction(() => store.createUser(userForCreation));
};

const performAction = (action: any) => {
  const handleSuccess = () => {
    router.push({ name: "users" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  const handleError = (err: any) => {
    if (err.response && err.response.status == 409)
      rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    if (err.response && err.response.status == 400)
      rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    if (err.response && err.response.status == 403)
      rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
  };

  action()
    .then(handleSuccess)
    .catch(handleError)
    .finally(() => {
      emit("setLoading", false);
    });
};

__expose({
  createUser,
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col", [isUserSetted.value ? 'fl-1' : 'input-container m-r-20']])
        }, [
          _hoisted_5,
          _createVNode(_unref(InputText), {
            placeholder: "Введите значение",
            autocomplete: "off",
            invalid: isInvalidForm.value && user.value.email == '',
            modelValue: user.value.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event))
          }, null, 8, ["invalid", "modelValue"])
        ], 2),
        (!isUserSetted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(IconField), {
                  iconPosition: "right",
                  class: "m-r-8 fl-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputIcon), {
                      class: _normalizeClass(["pi pointer", [passwordClosed.value ? 'pi-eye' : 'pi-eye-slash']]),
                      onClick: passClick
                    }, null, 8, ["class"]),
                    _createVNode(_unref(InputText), {
                      class: _normalizeClass([[passwordClosed.value ? 'closed' : 'opened'], "w-100"]),
                      placeholder: "Введите значение",
                      autocomplete: "off",
                      invalid: isInvalidForm.value && user.value.password == '',
                      modelValue: user.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event))
                    }, null, 8, ["class", "invalid", "modelValue"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_unref(Button), {
                  icon: "pi pi-bolt",
                  class: "purple-button",
                  "aria-label": "Сгенерировать пароль",
                  onClick: passGenerate
                }, null, 512), [
                  [
                    _directive_tooltip,
                    {
                value: 'Сгенерировать пароль',
                class: 'white-tooltip',
              },
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(InputText), {
            placeholder: "Введите значение",
            modelValue: user.value.lname,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.lname) = $event)),
            invalid: isInvalidForm.value && user.value.lname == ''
          }, null, 8, ["modelValue", "invalid"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_unref(InputText), {
            placeholder: "Введите значение",
            modelValue: user.value.fname,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.fname) = $event)),
            invalid: isInvalidForm.value && user.value.fname == ''
          }, null, 8, ["modelValue", "invalid"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(CatalogDataSingleInput, {
            useIdOnly: true,
            selectType: "organization",
            "is-invalid": isInvalidForm.value && user.value.organization == null,
            isSegmentSetted: false,
            modelValue: user.value.organization,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (user.value.organization = $event))
          }, null, 8, ["is-invalid", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_unref(Dropdown), {
            modelValue: user.value.department,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.department) = $event)),
            invalid: isInvalidForm.value && user.value.department == null,
            optionLabel: "name",
            options: departments.value,
            optionValue: "id",
            disabled: user.value.organization == null,
            placeholder: "Выберите значение",
            filter: ""
          }, null, 8, ["modelValue", "invalid", "options", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_unref(Dropdown), {
            modelValue: user.value.role,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.role) = $event)),
            invalid: isInvalidForm.value && user.value.role == null,
            optionLabel: "name",
            options: getRoles(),
            optionValue: "id",
            disabled: user.value.department == null || user.value.organization == null,
            placeholder: "Выберите значение",
            filter: ""
          }, null, 8, ["modelValue", "invalid", "options", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})